import { render, staticRenderFns } from "./HorseScoresTable.vue?vue&type=template&id=a99983fa&scoped=true&"
import script from "./HorseScoresTable.vue?vue&type=script&lang=js&"
export * from "./HorseScoresTable.vue?vue&type=script&lang=js&"
import style0 from "./HorseScoresTable.vue?vue&type=style&index=0&id=a99983fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99983fa",
  null
  
)

export default component.exports